import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FieldInput from '../../../Components/FieldInput'
import FieldSelect from '../../../Components/FieldSelect'
import Button from '../../../Components/Button'
import { useTranslation } from 'react-i18next'
import { AiTwotoneCloseCircle } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import API from '../../../Common/API'
import {setAlert} from '../../../Store/Theme/actions'

const maritalStatus = [{ text: 'Never Married', value: 'Never Married' },{text: 'Married', value: 'Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' }]
const tMaritalStatus = [{ text: 'திருமணம் செய்து கொள்ளவில்லை', value: 'Never Married' },{ text: 'திருமணமானவர்', value: 'Married' } ,{ text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' }]
const occupationField = [{ text: 'Agriculture', value: 'agriculture' }, { text: 'Politics', value: 'politics' }, { text: 'Business', value: 'business' }, { text: 'Govt', value: 'govt' }, { text: 'Private', value: 'private' }, { text: 'Not working', value: 'notWorking' }]
const tOccupationField = [
  { text: 'விவசாயம்', value: 'agriculture' },
  { text: 'அரசியல்', value: 'politics' },
  { text: 'வணிகம்', value: 'business' },
  { text: 'அரசு', value: 'govt' },
  { text: 'தனியார்', value: 'private' },
  { text: 'Not working', value: 'notWorking' }
]

const relationshipOptions = [
  { text: 'Father', value: 'father' },
  { text: 'Mother', value: 'mother' },
  { text: 'Wife', value: 'wife' },
  { text: 'Husband', value: 'husband' },
  { text: 'Son', value: 'son' },
  { text: 'Daughter', value: 'daughter' },
  { text: 'Elder Brother', value: 'elderBrother' },
  { text: 'Younger Brother', value: 'youngerBrother' },
  { text: 'Elder Sister', value: 'elderSister' },
  { text: 'Younger Sister', value: 'youngerSister' },
  { text: 'Grandfather', value: 'grandfather' },
  { text: 'Grandmother', value: 'grandmother' },
];

const tRelationshipOptions = [
  { text: 'தந்தை', value: 'father' },
  { text: 'தாய்', value: 'mother' },
  { text: 'மனைவி', value: 'wife' },
  { text: 'கணவர்', value: 'husband' },
  { text: 'மகன்', value: 'son' },
  { text: 'மகள்', value: 'daughter' },
  { text: 'அண்ணன்', value: 'elderBrother' },
  { text: 'தம்பி', value: 'youngrBrother' },
  { text: 'அக்கா', value: 'elderSister' },
  { text: 'தங்கை', value: 'youngerSister' },
  { text: 'தாத்தா', value: 'grandfather' },
  { text: 'பாட்டி', value: 'grandmother' }
];

const initialFamilyHistory = {
  familyHeadName: '',
  familyHeadFatherName: '',
  permanentAddress: '',
  temporaryAddress: '',
  nativeAddress: "",
  mobileNumber: '',
  whatsappNumber: '',
  noOfFamilyMembers: 0,
  familyMembersDetails: [{
    name: '',
    age: 0,
    surname :'',
    qualification: '',
    maritalStatus: '',
    occupation: '',
    occupationPosition: '',
    landArea: '',
    occupationLocation: '',
    company: '',
    businessProof: '',
    businessAddress: '',
    businessName: '',
    familyHeadRealtedWith: '',
  }],
  marriedMemberDetails: [{
    name: '',
    spouseName: '',
    spouseSurname: '',
    spouseAge: 0,
    spouseQualification: '',
    spouseNative: '',
    spouseMobile: '',
    spouseAddress: '',
    spouseOccupation: '',
    spouseOccupationPosition: '',
    landArea: '',
    occupationLocation: '',
    company: '',
    businessProof: '',
    businessAddress: '',
    businessName: '',
  }],
}

const FamilyHistory = () => {

  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const userDetails = useSelector((state)=>state.auth.userDetails)
  const lang = useSelector((state) => state.theme.language)
  const [familyDetails,setFamilyDetails] = useState(initialFamilyHistory)

  useEffect(()=>{
    try{
      API.get('/families/getFamilyHistory').then((getRes)=>{
        if(getRes.status === 200){
          setFamilyDetails({...initialFamilyHistory,...getRes.data.data})
        }
      })
    }catch(err){
      console.log(err)
    }
  },[])

  const familyHistorySchema = Yup.object().shape({
    familyHeadName: Yup.string().required('Required'),
    familyHeadFatherName: Yup.string().required('Required'),
    permanentAddress: Yup.string().required('Required'),
    temporaryAddress: Yup.string().required('Required'),
    nativeAddress: Yup.string().required('Required'),
    mobileNumber: Yup.string().matches(/^[6-9]\d{9}$/, 'Invalid mobile number'),
    whatsappNumber: Yup.string().matches(/^[6-9]\d{9}$/, 'Invalid WhatsApp number'),
    noOfFamilyMembers: Yup.number().min(0).required('Required'),
    familyMembersDetails: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required(),
        age: Yup.number().min(0).required(),
        qualification: Yup.string().nullable(),
        maritalStatus: Yup.string().nullable(),
        occupation: Yup.string().nullable(),
        occupationPosition: Yup.string().nullable(),
        landArea: Yup.string().nullable(),
        occupationLocation: Yup.string().nullable(),
        company: Yup.string().nullable(),
        businessProof: Yup.string().nullable(),
        businessAddress: Yup.string().nullable(),
        businessName: Yup.string().nullable(),
        familyHeadRealtedWith: Yup.string().nullable(),
      })
    ),
    marriedMemberDetails: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().nullable(),
        spouseName: Yup.string().nullable(),
        spouseSurname: Yup.string().nullable(),
        spouseAge: Yup.number().min(0),
        spouseQualification: Yup.string().nullable(),
        spouseNative: Yup.string().nullable(),
        spouseMobile: Yup.string().matches(/^[6-9]\d{9}$/, 'Invalid mobile number'),
        spouseAddress: Yup.string().nullable(),
        spouseOccupation: Yup.string().nullable(),
        spouseOccupationPosition: Yup.string().nullable(),
        landArea: Yup.string().nullable(),
        occupationLocation: Yup.string().nullable(),
        company: Yup.string().nullable(),
        businessProof: Yup.string().nullable(),
        businessAddress: Yup.string().nullable(),
        businessName: Yup.string().nullable(),
      })
    ),
  });
  const historyForm = useFormik({
    initialValues: familyDetails,
    validateOnMount: true,
    validationSchema: familyHistorySchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      values.userId = userDetails._id
      if(values._id){ 
        console.log(values.toString())
        API.post(`/families/editFamilyHistory/${values._id}`,values).then((familyRes)=>{
          if(familyRes.status === 200){
          dispatch(setAlert({title:'Success',subtitle:'Family history edited successfully',type:'success',active:true}))  
          }
        })
      }else{
        API.post('/families/addFamilyHistory',values).then((familyRes)=>{
        if(familyRes.status === 200){
          dispatch(setAlert({title:'Success',subtitle:'Family history added successfully',type:'success',active:true}))
        }
      })
      }
    }
  })

  const addHistoryFields = () => {
    const values = {
      name: '',
      age: 0,
      qualification: '',
      maritalStatus: '',
      occupation: '',
      occupationPosition: '',
      landArea: '',
      occupationLocation: '',
      company: '',
      businessProof: '',
      businessAddress: '',
      businessName: '',
      familyHeadRealtedWith: '',
    };

    // Append new member instead of replacing
    const currentMembers = historyForm.values.familyMembersDetails || [];
    historyForm.setFieldValue('familyMembersDetails', [...currentMembers, values]);
  };


  const addMarriedMemberDetails = () => {
    const values = {
              name: '',
              spouseName: '',
              spouseSurname: '',
              spouseAge: 0,
              spouseQualification: '',
              spouseNative: '',
              spouseMobile: '',
              spouseAddress: '',
              spouseOccupation: '',
              spouseOccupationPosition: '',
              landArea: '',
              occupationLocation: '',
              company: '',
              businessProof: '',
              businessAddress: '',
              businessName: ''
    };

    // Append new member instead of replacing
    const currentMembers = historyForm.values.marriedMemberDetails || [];
    historyForm.setFieldValue('marriedMemberDetails', [...currentMembers, values]);
  };

  return (
    <motion.div className="flex flex-col py-10 relative min-h-screen w-full">
      <motion.div className='grid grid-cols-4 sm:grid-cols-1 md:grid-cols-4'>
        <FieldInput label={t('Family Head Name')} fieldProps={historyForm.getFieldProps('familyHeadName')} fieldHelper={historyForm.getFieldHelpers('familyHeadName')} fieldMeta={historyForm.getFieldMeta('familyHeadName')} edit={true} dataLoaded={true} />
        <FieldInput label={t('Family Head Father Name')} fieldProps={historyForm.getFieldProps('familyHeadFatherName')} fieldHelper={historyForm.getFieldHelpers('familyHeadFatherName')} fieldMeta={historyForm.getFieldMeta('familyHeadFatherName')} edit={true} dataLoaded={true} />
        <FieldInput label={(t('Permanent Address'))} type='textarea' fieldHelper={historyForm.getFieldHelpers('permanentAddress')} fieldMeta={historyForm.getFieldMeta('permanentAddress')} fieldProps={historyForm.getFieldProps('permanentAddress')} edit={true} dataLoaded={true} />
        <FieldInput label={(t('Temporary Address'))} type='textarea' fieldHelper={historyForm.getFieldHelpers('temporaryAddress')} fieldMeta={historyForm.getFieldMeta('temporaryAddress')} fieldProps={historyForm.getFieldProps('temporaryAddress')} edit={true} dataLoaded={true} />
        <FieldInput label={(t('Native Address'))} type='textarea' fieldHelper={historyForm.getFieldHelpers('nativeAddress')} fieldMeta={historyForm.getFieldMeta('nativeAddress')} fieldProps={historyForm.getFieldProps('nativeAddress')} edit={true} dataLoaded={true} />
        <FieldInput label={t('Mobile Number')} type="phone" fieldHelper={historyForm.getFieldHelpers('mobileNumber')} fieldMeta={historyForm.getFieldMeta('mobileNumber')} fieldProps={historyForm.getFieldProps('mobileNumber')} edit={true} dataLoaded={true} />
        <FieldInput label={t('Whatsapp Number')} type="phone" fieldHelper={historyForm.getFieldHelpers('whatsappNumber')} fieldMeta={historyForm.getFieldMeta('whatsappNumber')} fieldProps={historyForm.getFieldProps('whatsappNumber')} edit={true} dataLoaded={true} />
        <FieldInput type='number' label={t('No of family members')} fieldHelper={historyForm.getFieldProps('noOfFamilyMembers')} fieldMeta={historyForm.getFieldMeta('noOfFamilyMembers')} fieldProps={historyForm.getFieldProps('noOfFamilyMembers')} edit={true} dataLoaded={true} />
      </motion.div>
      <motion.div className='flex flex-col w-full'>
        <p className='text-black font-bold py-2'>Family Member Details</p>
        {
          historyForm.values.familyMembersDetails && historyForm.values.familyMembersDetails.map((fam, index) => {
            return <motion.div
              key={index}
              className="grid grid-cols-4 gap-4 w-full border border-gray-300 rounded-lg p-4 mb-4 relative"
            >
              <FieldInput
                label={t('Name')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].name`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].name`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].name`)}
                edit={true}
                dataLoaded={true}
              />
               <FieldInput
                label={t('Surname')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].surname`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].surname`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].surname`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                type="number"
                label={t('Age')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].age`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].age`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].age`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Qualification')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].qualification`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].qualification`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].qualification`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldSelect
                label={t('Marital Status')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].maritalStatus`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].maritalStatus`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].maritalStatus`)}
                edit={true}
                options={lang === 'en' ? maritalStatus : tMaritalStatus} 
                dataLoaded={true}
              />
              <FieldSelect
                label={t('Related With Head')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].familyHeadRealtedWith`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].familyHeadRealtedWith`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].familyHeadRealtedWith`)}
                edit={true}
                options={lang === 'en' ? relationshipOptions : tRelationshipOptions}
                dataLoaded={true}
              />
              <FieldSelect
                label={t('Occupation')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].occupation`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].occupation`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].occupation`)}
                edit={true}
                options={lang === 'en' ? occupationField : tOccupationField}
                dataLoaded={true}
              />
              {
                fam.occupation === 'agriculture' && <FieldInput
                  label={t('Land Area')}
                  fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].landArea`)}
                  fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].landArea`)}
                  fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].landArea`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                fam.occupation === 'agriculture' && <FieldInput
                  label={t('Land Location')}
                  fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].landLocation`)}
                  fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].landLocation`)}
                  fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].landLocation`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                fam.occupation === 'business' && <FieldInput
                  label={t('Business')}
                  fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].businessName`)}
                  fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].businessName`)}
                  fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].businessName`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                fam.occupation === 'business' && <FieldInput
                  label={t('Business Proof')}
                  type='file'
                  fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].businessProof`)}
                  fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].businessProof`)}
                  fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].businessProof`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                fam.occupation === 'business' && <FieldInput
                  type='textarea'
                  label={t('Business Address')}
                  fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].businessAddress`)}
                  fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].businessAddress`)}
                  fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].businessAddress`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {(fam.occupation !== 'agriculture' && fam.occupation !== 'business' && fam.occupation !== 'notWorking' && fam.occupation !== 'politics') && <FieldInput
                label={t('Designation')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].occupationPosition`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].occupationPosition`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].occupationPosition`)}
                edit={true}
                dataLoaded={true}
              />}
              {(fam.occupation !== 'agriculture' && fam.occupation !== 'business' && fam.occupation !== 'notWorking' && fam.occupation !== 'politics') && <FieldInput
                label={t('Occupation Location')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].occupationLocation`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].occupationLocation`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].occupationLocation`)}
                edit={true}
                dataLoaded={true}
              />}
              {(fam.occupation !== 'agriculture' && fam.occupation !== 'business' && fam.occupation !== 'notWorking' && fam.occupation !== 'politics' && fam.occupation !== 'govt') && <FieldInput
                label={t('Company')}
                fieldProps={historyForm.getFieldProps(`familyMembersDetails[${index}].company`)}
                fieldMeta={historyForm.getFieldMeta(`familyMembersDetails[${index}].company`)}
                fieldHelper={historyForm.getFieldHelpers(`familyMembersDetails[${index}].company`)}
                edit={true}
                dataLoaded={true}
              />}

              {/* Remove button */}
              <button
                type="button"
                onClick={() => {
                  const updatedMembers = [...historyForm.values.familyMembersDetails];
                  updatedMembers.splice(index, 1);
                  historyForm.setFieldValue('familyMembersDetails', updatedMembers);
                }}
                className="absolute -top-3 -right-3 text-red-500 hover:text-red-700"
                title="Remove Member"
              >
                <AiTwotoneCloseCircle />
              </button>
            </motion.div>
          })
        }
        <button
          type="button"
          onClick={() =>
            addHistoryFields()
          }
          className="flex items-center space-x-2 text-green-600 hover:text-green-800 mt-2"
        >
          {/* <PlusCircle className="w-5 h-5" /> */}
          <span>{t('Add Family Member')}</span>
        </button>
      </motion.div>
      <motion.div className='flex flex-col w-full mt-10'>
        <p className='text-black font-bold py-2'>Married Member Details</p>
        {
          historyForm.values.marriedMemberDetails &&
          historyForm.values.marriedMemberDetails.map((married, index) => (
            <motion.div
              key={index}
              className="grid grid-cols-4 gap-4 w-full border border-gray-300 rounded-lg p-4 mb-4 relative"
            >
              <FieldInput
                label={t('Name')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].name`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].name`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].name`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Name')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseName`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseName`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseName`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Surname')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseSurname`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseSurname`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseSurname`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                type="number"
                label={t('Spouse Age')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseAge`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseAge`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseAge`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Qualification')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseQualification`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseQualification`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseQualification`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Native')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseNative`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseNative`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseNative`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Mobile')}
                type="phone"
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseMobile`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseMobile`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseMobile`)}
                edit={true}
                dataLoaded={true}
              />
              <FieldSelect
                label={t('Occupation')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].occupation`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].occupation`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].occupation`)}
                edit={true}
                options={lang === 'en' ? occupationField : tOccupationField}
                dataLoaded={true}
              />
              <FieldInput
                label={t('Spouse Address')}
                type="textarea"
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].spouseAddress`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].spouseAddress`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].spouseAddress`)}
                edit={true}
                dataLoaded={true}
              />
              {
                married.occupation === 'agriculture' && <FieldInput
                  label={t('Land Area')}
                  fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].landArea`)}
                  fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].landArea`)}
                  fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].landArea`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                married.occupation === 'agriculture' && <FieldInput
                  label={t('Land Location')}
                  fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].landLocation`)}
                  fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].landLocation`)}
                  fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].landLocation`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                married.occupation === 'business' && <FieldInput
                  label={t('Business')}
                  fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].businessName`)}
                  fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].businessName`)}
                  fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].businessName`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                married.occupation === 'business' && <FieldInput
                  label={t('Business Proof')}
                  type='file'
                  fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].businessProof`)}
                  fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].businessProof`)}
                  fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].businessProof`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {
                married.occupation === 'business' && <FieldInput
                  type='textarea'
                  label={t('Business Address')}
                  fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].businessAddress`)}
                  fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].businessAddress`)}
                  fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].businessAddress`)}
                  edit={true}
                  dataLoaded={true}
                />
              }
              {(married.occupation !== 'agriculture' && married.occupation !== 'business' && married.occupation !== 'notWorking' && married.occupation !== 'politics') && <FieldInput
                label={t('Designation')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].occupationPosition`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].occupationPosition`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].occupationPosition`)}
                edit={true}
                dataLoaded={true}
              />}
              {(married.occupation !== 'agriculture' && married.occupation !== 'business' && married.occupation !== 'notWorking' && married.occupation !== 'politics') && <FieldInput
                label={t('Occupation Location')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].occupationLocation`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].occupationLocation`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].occupationLocation`)}
                edit={true}
                dataLoaded={true}
              />}
              {(married.occupation !== 'agriculture' && married.occupation !== 'business' && married.occupation !== 'notWorking' && married.occupation !== 'politics' && married.occupation !== 'govt') && <FieldInput
                label={t('Company')}
                fieldProps={historyForm.getFieldProps(`marriedMemberDetails[${index}].company`)}
                fieldMeta={historyForm.getFieldMeta(`marriedMemberDetails[${index}].company`)}
                fieldHelper={historyForm.getFieldHelpers(`marriedMemberDetails[${index}].company`)}
                edit={true}
                dataLoaded={true}
              />}

              {/* Remove button */}
              <button
                type="button"
                onClick={() => {
                  const updated = [...historyForm.values.marriedMemberDetails];
                  updated.splice(index, 1);
                  historyForm.setFieldValue('marriedMemberDetails', updated);
                }}
                className="absolute -top-3 -right-3 text-red-500 hover:text-red-700"
                title="Remove Member"
              >
                <AiTwotoneCloseCircle />
              </button>
            </motion.div>
          ))
        }

        <button
          type="button"
          onClick={() =>addMarriedMemberDetails()}
          className="flex items-center space-x-2 text-green-600 hover:text-green-800 mt-2"
        >
          <span>{t('Add Married Member')}</span>
        </button>
      </motion.div>
      <motion.div className='w-full flex flex-row justify-center'>
        <motion.div className='flex flex-row w-fit justify-center items-center text-center px-10 py-5'>
          <Button type='secondary' injectClass={'w-fit'} onClick={() => history.goBack()}>Cancel</Button>
          <Button type="primary" injectClass={'w-fit'} onClick={() => historyForm.submitForm()}>Submit</Button>
        </motion.div>
      </motion.div>
    </motion.div>
  )
}

export default FamilyHistory